type SupportedLocale = 'ru'

export const SUPPORTED_LOCALES: SupportedLocale[] = ['ru']

export const getLocale = (): SupportedLocale => 'ru'
